// extracted by mini-css-extract-plugin
export default {"root":"EA4hJ8","title":"fOenQm"};